import { BANK_PAYMENT_TRANSACTION_REQUEST, GET_BANK_PAYMENT_TRANSACTIONS, BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE, GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_PAYMENT_TRANSACTIONS } from '../types';

const initialState = {
  bankPaymentTransactions: [],
  accountIdWiseConsigneeBankPaymentTransactions: [],
  loading: false,
  error: null,
};

const bankPaymentTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_PAYMENT_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_PAYMENT_TRANSACTIONS: {
      return {
        ...state,
        bankPaymentTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_PAYMENT_TRANSACTIONS: {
      const { data } = action.payload || {};
      return {
        ...state,
        accountIdWiseConsigneeBankPaymentTransactions: [...data],
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankPaymentTransactionReducer;